import styled from 'styled-components';

const PagionationDotContainer = styled.div<React.CSSProperties>``;

export default PagionationDotContainer;
